export default [
    {
        name: 'Merry Christmas',
        ID: 1,
    },
    {
        name: 'Seasons Greetings',
        ID: 2,
    },
    {
        name: 'Christmas Wishes',
        ID: 3,
    },
    {
        name: 'Warm Christmas Wishes',
        ID: 4,
    },
];
